import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import {
  Card,
  CardHeader,
  CardMedia,
  CardContent,
  CardActions,
  CardActionArea,
  Collapse,
  Avatar,
  IconButton,
  Typography,
} from '@material-ui/core'
import { map } from 'lodash'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { Theme } from '../../utils/Theme'
import Box from 'components/UI/Box'
import IconTag from '../UI/IconTag'
import Tooltip from '@material-ui/core/Tooltip'
import Section from 'components/UI/Section';

const useStyles = makeStyles(theme => ({
  ...Theme(),
  root: {
    minHeight: 250,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
}))

const SectionCard = ({ avatar, AvatarIcon, title, subtitle, media, content, actions, moreActions, className }) => {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  const cardClick = ()=>{
    if ( actions.length === 1 && !content ) {
        actions[0].onClick()
    }
  }


  return (
    <Section elevation={0} className={clsx(classes.root, className)}>
      <CardHeader
        avatar={
          (avatar || AvatarIcon) && (
            <Avatar aria-label="recipe" className={classes.backgroundPrimary}>
              {AvatarIcon && <IconTag name={AvatarIcon} />}
              {avatar}
            </Avatar>
          )
        }
        action={
          moreActions && (
            <IconButton aria-label="settings">
              <MoreVertIcon />
            </IconButton>
          )
        }
        title={title && title}
        subheader={subtitle && subtitle}
      />
      {media && <CardMedia className={classes.media} image="/static/images/cards/paella.jpg" title="Paella dish" />}

      <Box style={{ overflow: 'hidden', height: (!content || !expanded) && 150 }}>
        {content && (
          <CardContent component="div">
            <Typography variant="body2" color="textSecondary" component="p" style={{ whiteSpace: 'pre-wrap' }}>
              {!expanded && content.length > 200 ? `${content.slice(0, 200)} ...` : content}
            </Typography>
            {content && content.length > 200 && (
              <Collapse in={expanded} timeout="auto" unmountOnExit>
                <Typography variant="body2" color="textSecondary" component="p" style={{ whiteSpace: 'pre-wrap' }}>
                  {content.length}
                </Typography>
              </Collapse>
            )}
          </CardContent>
        )}
      </Box>
      <CardActionArea>
        <CardActions className={classes.actions} disableSpacing onClick={cardClick}>
          {actions &&
            map(actions, ({ label, onClick, Icon }, index) => (
              <Tooltip title={label} key={index}>
                <IconButton
                  aria-label={label}
                  onClick={onClick}
                  className={clsx(classes.colorPrimary, classes.backgroundLight)}
                >
                  <IconTag name={Icon} className={classes.colorPrimary} />
                </IconButton>
              </Tooltip>
            ))}
          {content && content.length > 200 && (
            <IconButton
              className={clsx(classes.expand, {
                [classes.expandOpen]: expanded,
              })}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
            >
              <ExpandMoreIcon className={classes.colorPrimary} />
            </IconButton>
          )}
        </CardActions>
      </CardActionArea>
    </Section>
  )
}

SectionCard.propTypes = {
  avatar: PropTypes.any,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  media: PropTypes.string,
  content: PropTypes.string,
  actions: PropTypes.array,
  moreActions: PropTypes.array,
  AvatarIcon: PropTypes.any,
  className: PropTypes.string,
}

export default SectionCard
